module.exports = __webpack_public_path__ + "static/media/Michigan_DMA.f061b6b3.png";